import { Component, ElementRef, HostListener, Input, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faEllipsisH } from '@fortawesome/free-solid-svg-icons';
import { UiButtonComponent } from '../button/ui-button.component';
import { RowAction } from './row-action.model';

@Component({
  selector: 'ui-row-actions',
  standalone: true,
  imports: [CommonModule, FontAwesomeModule, UiButtonComponent],
  templateUrl: './ui-row-actions.component.html',
})
export class UiRowActionsComponent {
  @Input() actions: RowAction[] = [];
  /** Controls desktop button rendering. The submenu always shows icon + label. */
  @Input() mode: 'icon' | 'label' | 'icon-label' = 'icon-label';

  readonly faEllipsisH = faEllipsisH;
  private readonly hostRef = inject(ElementRef<HTMLElement>);

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const openDropdowns = this.hostRef.nativeElement.querySelectorAll(
      'details.dropdown[open]'
    ) as NodeListOf<HTMLDetailsElement>;
    const target = event.target as Node | null;
    openDropdowns.forEach((d) => {
      if (target && !d.contains(target)) {
        d.removeAttribute('open');
      }
    });
  }

  menuItemClass(a: RowAction): string {
    const classes: string[] = [];
    if (a.variant === 'danger') classes.push('text-error');
    if (a.disabled) classes.push('opacity-40', 'cursor-not-allowed');
    return classes.join(' ');
  }

  onMenuClick(a: RowAction, event: Event, detailsEl: HTMLDetailsElement): void {
    if (a.disabled || a.loading) {
      event.preventDefault();
      return;
    }
    a.onClick(event);
    detailsEl.removeAttribute('open');
  }
}